import { db } from './firebase';
import { ref as dRef, set } from 'firebase/database';

const CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export function isPhotosConfigured() {
  return Boolean(CLOUD && PRESET);
}

// Téléverse un fichier sur Cloudinary (upload non signé). Appelé seulement
// au moment d'enregistrer, pour ne rien envoyer si l'admin annule.
export async function uploadFile(file) {
  if (!isPhotosConfigured()) throw new Error('Cloudinary non configuré');
  const form = new FormData();
  form.append('file', file);
  form.append('upload_preset', PRESET);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD}/image/upload`, {
    method: 'POST',
    body: form,
  });
  const data = await res.json();
  if (!data.secure_url) {
    throw new Error((data.error && data.error.message) || "Échec de l'upload Cloudinary");
  }
  return {
    url: data.secure_url,
    publicId: data.public_id,
    width: data.width || 0,
    height: data.height || 0,
  };
}

// Enregistre la liste des photos (nettoie les undefined que RTDB refuse).
export function savePhotos(photos) {
  const clean = JSON.parse(JSON.stringify(photos));
  return set(dRef(db, 'photos'), clean);
}

// L'upload non signé ne permet pas de supprimer le fichier côté navigateur :
// on retire la fiche de la base ; le fichier reste sur Cloudinary (inoffensif).
export async function deletePhotoFile() {
  return Promise.resolve();
}
